<div class="bottom-nav__container" [class.bottom-nav__container--mobile]="hasClientSmallScreen()"
  [class.bottom-nav__container--desktop]="!hasClientSmallScreen()">
  <div class="bottom-nav__content">
    <!-- First 2 nav items -->
    @for (item of items.slice(0, 2); track item) {
      <button class="bottom-nav__item"
        [class.bottom-nav__item--active]="isItemActive(item)" [class.bottom-nav__item--disabled]="!isItemEnabled(item)"
        [disabled]="!isItemEnabled(item)" (click)="handleItemClick(item)">
        <cs-icon [name]="item.icon" [fill]="isItemActive(item)" class="bottom-nav__icon"></cs-icon>
        <span class="bottom-nav__label">{{ item.label }}</span>
      </button>
    }

    <!-- Central button: play icon for workout pages, add icon otherwise -->
    <cs-button small class="bottom-nav__add-button" [class.bottom-nav__add-button--play]="isWorkoutStartMode"
      [disabled]="!addButtonEnabled" (click)="handleCenterButtonClick()">
      <cs-icon [name]="isWorkoutStartMode ? 'play' : 'add'" [fill]="isWorkoutStartMode"></cs-icon>
    </cs-button>

    <!-- Last 2 nav items -->
    @for (item of items.slice(2); track item) {
      <button class="bottom-nav__item"
        [class.bottom-nav__item--active]="isItemActive(item)" [class.bottom-nav__item--disabled]="!isItemEnabled(item)"
        [disabled]="!isItemEnabled(item)" (click)="handleItemClick(item)">
        <cs-icon [name]="item.icon" [fill]="isItemActive(item)" class="bottom-nav__icon"></cs-icon>
        <span class="bottom-nav__label">{{ item.label }}</span>
      </button>
    }
  </div>
</div>